 <div class="contains__table">
  <div class="section__table">
    <table class="table">
      <thead>
        <tr style="background-color: var(--light-00);">
          <ng-container *ngFor="let header of cabecalhos">
            <th *ngIf="!mostraOuEscondeColuna(header)">
              {{ header }}
            </th>
          </ng-container>
        </tr>
      </thead>
        <tbody class="scrollable-content">
          <ng-content></ng-content>
        </tbody>
    </table>
  </div>
</div>
